/**
 * Marker editor InfoWindow form chrome (tabs, sections, sticky actions).
 * Google Maps .gm-style overrides live in styles/thirdParty/googleMapsInfoWindow.css.
 */

import { chromeShell } from "./chromeShell";
import { typeShell } from "./typeShell";

const { scrollThin } = chromeShell;

export const markerEditorShell = {
    wrapper:
        "relative box-border flex h-full w-full min-w-0 max-w-full items-center justify-center overflow-hidden p-0 max-[768px]:!p-3 max-[440px]:!p-2",

    container: `box-border m-0 flex h-full max-h-full w-full min-w-0 max-w-full flex-col overflow-hidden rounded-xl bg-surface p-4 font-sans bp-2xl:p-6 ${scrollThin} max-[768px]:!m-0 max-[768px]:!h-full max-[768px]:!max-h-full max-[768px]:!min-h-0 max-[768px]:!w-full max-[768px]:!rounded-xl max-[768px]:!p-3 max-[440px]:!flex max-[440px]:!h-full max-[440px]:!max-h-full max-[440px]:!min-h-0 max-[440px]:!w-full max-[440px]:!flex-col max-[440px]:!overflow-hidden max-[440px]:!rounded-lg max-[440px]:!bg-surface max-[440px]:!p-2`,

    /** Absolute over editor chrome — not part of headerRow */
    closeButton: `absolute right-2 top-2 z-20 ${chromeShell.iconClose} max-[440px]:right-1 max-[440px]:top-1`,

    headerRow:
        "mb-0 mt-0 flex min-h-0 shrink-0 items-center justify-between gap-3 border-0 border-b-2 border-solid border-border-light p-0 pb-2 pt-10 pr-2 max-[440px]:!flex-col max-[440px]:!items-stretch max-[440px]:flex-wrap max-[440px]:gap-2 max-[440px]:pb-1.5 max-[440px]:pt-9",

    headerLeft:
        "flex min-w-0 flex-1 items-center gap-3 max-[440px]:w-full max-[440px]:flex-wrap max-[440px]:gap-2",

    headerActions:
        "flex shrink-0 items-center gap-2 max-[440px]:w-full",

    header: `m-0 flex shrink-0 items-center gap-2 p-0 ${typeShell.panelTitle} max-[440px]:mb-0`,

    creatorInfo:
        `flex h-fit shrink-0 items-center gap-1.5 rounded border border-solid border-border-light bg-surface-muted px-2.5 py-1.5 max-[440px]:flex-wrap max-[440px]:px-2 max-[440px]:py-1 ${typeShell.metaValue}`,

    metaLabel: `m-0 inline ${typeShell.metaLabel}`,
    metaValue: `m-0 inline ${typeShell.metaValue}`,

    tabs: "mb-0 flex shrink-0 gap-2 max-[440px]:w-full max-[440px]:justify-start max-[440px]:gap-1",

    tab: `relative bottom-[-0.5rem] mb-0 flex cursor-pointer items-center gap-1.5 border-0 border-b-2 border-solid bg-transparent px-4 py-2.5 transition-[color,border-color] duration-200 hover:text-button-primary max-[440px]:bottom-[-0.375rem] max-[440px]:gap-1 max-[440px]:px-3 max-[440px]:py-2 ${typeShell.tabLabel} [&_.material-symbols-outlined]:align-middle [&_.material-symbols-outlined]:text-icon-control`,

    tabInactive: "border-b-transparent text-text-muted",
    tabActive: "border-b-button-primary text-button-primary",

    content: `mt-2 flex min-h-0 w-full min-w-0 max-w-full flex-1 flex-col gap-2 overflow-hidden pr-2 pt-1 ${scrollThin} max-[440px]:mt-1 max-[440px]:gap-2 max-[440px]:pr-1.5`,

    section: `box-border flex min-h-0 w-full min-w-0 max-w-full flex-1 flex-col gap-2 overflow-x-hidden overflow-y-auto overscroll-y-contain rounded-lg border border-solid border-border-light bg-surface p-3 bp-2xl:gap-4 bp-2xl:p-4 max-[440px]:gap-2 max-[440px]:p-4 ${scrollThin}`,

    /** Grow into spare height; never shrink below content so the section scrolls instead. */
    thumbnailSection: "mb-0 flex w-full grow shrink-0 flex-col gap-1",

    /** Shared fixed height for title input + label select (overrides formShell py) */
    field: "!box-border !h-11 !min-h-11 !max-h-11 w-full !py-0 !leading-none appearance-none",

    /** Reserve one line so showing/hiding errors does not shift layout */
    errorSlot: "m-0 min-h-5 leading-5",

    formRow: "flex w-full shrink-0 flex-col gap-3 bp-md:flex-row bp-md:items-start",

    finalActions:
        "sticky bottom-0 z-10 mb-0 mt-auto box-border flex min-h-8 w-full min-w-0 max-w-full shrink-0 items-center justify-end gap-3 bg-surface pb-1 pt-1 max-[440px]:gap-2",

    buttonSave:
        "shrink-0 min-w-28 disabled:!bg-text-hint disabled:!text-text-inverse disabled:!opacity-100 disabled:hover:!bg-text-hint max-[440px]:min-w-[5.5rem]",

    buttonDeleteBottom:
        "shrink-0 min-w-28 max-[440px]:min-w-[5.5rem]",
};

/**
 * @param {boolean} active
 */
export function markerEditorTabClass(active) {
    return `${markerEditorShell.tab} ${
        active ? markerEditorShell.tabActive : markerEditorShell.tabInactive
    }`.trim();
}
